module.exports = __webpack_public_path__ + "img/proyecto7.2bf467a4.png";